import { Facebook, Copy } from "lucide-react";
import { Button } from "@/components/ui/button";

const STEPS = [
  "Apri la tua Pagina Facebook dal computer o dall'app (devi esserne amministratore).",
  "Sotto la foto di copertina clicca su \"+ Aggiungi pulsante\" (oppure su \"Modifica pulsante\" se ne hai già uno).",
  "Scegli \"Prenota con te\" / \"Prenota ora\" e poi l'opzione \"Link a un sito web\".",
  "Incolla il tuo link di prenotazione (pulsante qui sotto) e salva.",
  "Facoltativo: nelle impostazioni di Messenger imposta una risposta automatica di benvenuto con il link: \"Ciao! Per fissare un appuntamento o chattare con il mio assistente clicca qui: <link>\".",
  "Pubblica anche un post o una storia con il link e fissalo in alto sulla Pagina.",
];

export const FacebookGuide = ({ link, onCopy }) => (
  <section className="bg-white border border-slate-200/80 rounded-xl p-6 space-y-4" data-testid="facebook-guide">
    <div className="flex items-center gap-3">
      <div className="h-10 w-10 rounded-lg bg-[#1877F2] text-white grid place-items-center"><Facebook className="h-5 w-5" /></div>
      <div>
        <h3 className="font-display font-semibold">Pulsante "Prenota" su Facebook</h3>
        <p className="text-sm text-slate-500">I clienti cliccano il pulsante sulla tua Pagina e prenotano o chattano con l'assistente AI.</p>
      </div>
    </div>
    <ol className="space-y-2.5">
      {STEPS.map((s, i) => (
        <li key={i} className="flex gap-3 text-sm text-slate-700">
          <span className="h-6 w-6 shrink-0 rounded-full bg-slate-100 text-slate-700 grid place-items-center text-xs font-bold">{i + 1}</span>
          <span>{s}</span>
        </li>
      ))}
    </ol>
    <Button data-testid="fb-copy-link" variant="outline" size="sm" onClick={onCopy}><Copy className="h-4 w-4 mr-1.5" />Copia il link da incollare: <span className="font-mono ml-1 truncate max-w-[260px]">{link}</span></Button>
  </section>
);
